import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { SaveButton, useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
	root: {
		marginLeft: theme.spacing(1),
	},
}));

export const SaveToEditButton = (props) => {
	const classes = useStyles();
	const t = useTranslate();

	return <SaveButton {...props} className={classes.root} redirect="show" />;
};
